import AuthFlowFrame from "../../components/AuthFlowFrame";
import { AuthFlowButton } from "../../types";
import { isJobberUrl } from "../../helpers";
import { Content } from "@jobber/components/Content";
import { Text } from "@jobber/components/Text";

const MARKETPLACE_URL = "https://secure.getjobber.com/marketplace";

function Step2() {
    const username = sessionStorage.getItem("instagram_username");

    // Return the user to wherever they launched from (passed through by Jobber),
    // but only if it's a trusted Jobber URL; otherwise fall back to the marketplace.
    const returnUrl = sessionStorage.getItem("jobber_return_url");
    const link = returnUrl && isJobberUrl(returnUrl) ? returnUrl : MARKETPLACE_URL;

    const button: AuthFlowButton = {
        link,
        text: "Return to Jobber",
        type: "secondary",
        disabled: false,
        loading: false,
    };

    return (
        <AuthFlowFrame
            pretitle={"You are all set"}
            title={"Your integration is ready to go!"}
            step={2}
            totalSteps={2}
            button={button}
        >
            <Content spacing={"base"}>
                <Text size={"large"}>
                    {username
                        ? <>Your Jobber account and Instagram (<strong>@{username}</strong>) are now connected.</>
                        : "Your Jobber account and Instagram are now connected."
                    }
                </Text>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step2;
